import { render, staticRenderFns } from "./interviewInbox.vue?vue&type=template&id=6f707dc6&"
import script from "./interviewInbox.vue?vue&type=script&lang=js&"
export * from "./interviewInbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports